export const BACKOFFICE_ROLES = ["administrador", "recepcionista"];
export const POS_ROLES = ["administrador", "recepcionista", "barbero", "cajero"];

export const canAccessBackoffice = (role) => BACKOFFICE_ROLES.includes(role);
export const canAccessPOS = (role) => POS_ROLES.includes(role);



